export const M_FILE_CUSTOM_02_Schema = {
  mapper: {
    /** 교육 자료 조회 getTbmNewR8 */
    search1: {
      UserId: (context) => context.userInfo?.userid,
    },
  },
};
